import { render, staticRenderFns } from "./EmptyState.vue?vue&type=template&id=6713c06e&scoped=true&"
import script from "./EmptyState.vue?vue&type=script&lang=js&"
export * from "./EmptyState.vue?vue&type=script&lang=js&"
import style0 from "./EmptyState.vue?vue&type=style&index=0&id=6713c06e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6713c06e",
  null
  
)

/* custom blocks */
import block0 from "./EmptyState.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6713c06e')) {
      api.createRecord('6713c06e', component.options)
    } else {
      api.reload('6713c06e', component.options)
    }
    module.hot.accept("./EmptyState.vue?vue&type=template&id=6713c06e&scoped=true&", function () {
      api.rerender('6713c06e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/EmptyState.vue"
export default component.exports